import type { ListColor } from '@lista/shared-types';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import styles from './ui.module.css';

export const LIST_COLORS: ListColor[] = [
  'DEFAULT',
  'RED',
  'ORANGE',
  'YELLOW',
  'GREEN',
  'TEAL',
  'BLUE',
  'INDIGO',
  'PURPLE',
  'PINK',
  'BROWN',
  'GRAY',
];

export const colorVars = (color: ListColor) => ({
  '--list-bg': `var(--list-${color.toLowerCase()}-bg)`,
  '--list-fg': `var(--list-${color.toLowerCase()}-fg)`,
});

/** Colour swatches as a radio group; each swatch is named for screen readers (frontend.md S-11). */
export function ColorPicker({
  value,
  onChange,
}: {
  value: ListColor;
  onChange(color: ListColor): void;
}) {
  const { t } = useTranslation();
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.label}>{t('lists.color')}</legend>
      <div className={styles.swatches}>
        {LIST_COLORS.map((c) => (
          <label
            key={c}
            className={styles.swatch}
            style={colorVars(c) as React.CSSProperties}
            title={t(`colors.${c.toLowerCase()}`)}
          >
            <input
              type="radio"
              name="list-color"
              value={c}
              checked={value === c}
              onChange={() => onChange(c)}
              className="visually-hidden"
            />
            <span className={styles.swatchDot}>
              {value === c && <Icon name="check" size={18} />}
            </span>
            <span className="visually-hidden">{t(`colors.${c.toLowerCase()}`)}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
